import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <h4 className="text-2xl font-semibold text-white mb-4">Nowest</h4>
            <p className="text-gray-400 mb-6 leading-relaxed">
              「覚えられない」を無くす。独自の記憶メソッドとAIチューター・AIゲームで、すべての人に学びの成功体験を提供します。
            </p>
          </div>

          <div>
            <h5 className="text-white font-semibold mb-4">サービス</h5>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white transition-colors cursor-pointer text-left"
                >
                  オンラインスクール
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white transition-colors cursor-pointer text-left"
                >
                  法人向け研修
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white transition-colors cursor-pointer text-left"
                >
                  コンテンツ制作
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-white font-semibold mb-4">会社情報</h5>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  会社概要
                </Link>
              </li>
              <li>
                <Link
                  to="/features"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  特徴
                </Link>
              </li>
              <li>
                <Link
                  to="/legal"
                  className="hover:text-white transition-colors cursor-pointer"
                >
                  特定商取引法
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-white transition-colors cursor-pointer text-left"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2025 Nowest,inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
